import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import './ScheduleSubject.module.scss';
import Select from 'react-select';
import { colourStyles } from 'utilities/colored-select-circle.js';
import nlDateString from 'utilities/nl-date-string';

/**
 * Import components
 */
import DropDown from 'components/UI/DropDown/DropDown';
import { Creator, Selector } from 'components/UI/Selectables/Selectables';
import Subject from 'components/UI/Subject/Subject';
import Checkbox from 'components/UI/Checkbox/Checkbox';
import Tip from 'components/UI/Tip/Tip';
import InputHomeworkForm from 'components/UI/Popup/InputHomework/components/InputHomeworkForm';

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { standardSubjects } from 'utilities/standard-subjects.js';

/**
 * Import actions
 */
import {
    homeworkSubject,
    homeworkReset
} from 'actions/new-homework';
import homeworkStore from 'actions/homework/store';
import homeworkUpdate from 'actions/homework/update';

import indexUserSubject from 'actions/usersubject/index';
import storeUserSubject from 'actions/usersubject/store';
import updateUserSubject from 'actions/usersubject/update';

import taskStore from "actions/task/store";

import getScheduleByDay from 'selectors/schedule/day';
import getUserSubjectWithDefaultSubjects from 'selectors/subject/user-subject-with-default';
import { userSubject, room, recurrence, duration, resetNewTimeslot } from 'actions/new-timeslot';
import storeEvent from 'actions/event/store';

const mapStateToProps = (state, props) => {
    return {
        new_usersubject: state.new_usersubject,
        subsWithDefault: getUserSubjectWithDefaultSubjects(state),
        homework: state.new_homework,
        subjects: state.user_subject.entities,
        colors: state.color.entities,
        schedule: state.authentication.user.schedule,
        user: state.authentication.user,
        auth: state.authentication,
        events: state.event,
        new_event: state.new_timeslot
    };
};

const mapDispatchToProps = {
    indexUserSubject,
    userSubject,
    room,
    storeEvent,
    recurrence,
    storeUserSubject,
    updateUserSubject,
    homeworkStore,
    homeworkSubject,
    homeworkReset,
    duration,
    resetNewTimeslot,
    taskStore
};

const customStyles = {
    control: styles => ({ 
        ...styles, 
        fontSize: '12px',
    }),
    option: styles => ({
        ...styles,
        fontSize: '12px',
    })
};

const recurrenceTypes = [
    {
        value: '',
        label: 'Geen'
    },
    {
        value: 'weekly',
        label: 'Elke week'
    },
    {
        value: 'biweekly',
        label: 'Elke 2 weken'
    },
    {
        value: 'montly',
        label: 'Elke 4 weken'
    },
];

const durationValues = [
    {
        value: 1,
        label: '1'
    },
    {
        value: 2,
        label: '2'
    },
    {
        value: 3,
        label: '3'
    },
    {
        value: 4,
        label: '4'
    },
    {
        value: 5,
        label: '5'
    },
    {
        value: 6,
        label: '6'
    },
    {
        value: 7,
        label: '7'
    },
    {
        value: 8,
        label: '8'
    },
];

const valueFromId = (opts, id) => opts.find(o => o && o.value === id);
const valueFromLabel = (opts, label) => opts.find(o => o && o.label === label);
const valueFromValue = (opts, value) => opts.find(o => o && o.value === value);

class InputHomework extends Component {

    constructor() {
        super();

        this.state = {
            day: '',
            month: '',
            year: '',
            showTip: false,
            recurrenceOption: 1,
            homeworkOpen: false,
            newSubjectDetails: false,
            subjectDirty: false,
            subject: null
        };

        this.storeHomework                      = this.storeHomework.bind(this);
        this.handleClose                        = this.handleClose.bind(this);
        this.toggleTip                          = this.toggleTip.bind(this);
        this.handleTimeslotChange               = this.handleTimeslotChange.bind(this);
        this.openImage                          = this.openImage.bind(this);
        this.handleRecurranceChange             = this.handleRecurranceChange.bind(this);
        this.toggleHomeworkOpen                 = this.toggleHomeworkOpen.bind(this);
        this.toggleSubjectDetails               = this.toggleSubjectDetails.bind(this);
        this.handleSubjectChange                = this.handleSubjectChange.bind(this);
        this.handleRoomChange                   = this.handleRoomChange.bind(this);
        this.saveEvent                          = this.saveEvent.bind(this);
        this.handleColorChange                  = this.handleColorChange.bind(this);
        this.handleSubjectDataChange            = this.handleSubjectDataChange.bind(this);
        this.findColor                          = this.findColor.bind(this);
        this.limitDuration                      = this.limitDuration.bind(this);
        this.handleCreateSubject                = this.handleCreateSubject.bind(this);
    }

    componentDidMount() {

        this.props.indexUserSubject();

        // if (this.props.subjects.allIds.length < 2) { //user always has the Other Task subject so if it is 0 (should not happen) or 1 (only Other Task), show alert

        //     alert('Je hebt nog geen vakken in je rooster, huiswerk plannen niet mogelijk.');
        //     this.props.handleClose();
        // }

        // if (!this.props.homework.subject && this.props.subjects.allIds.length > 1) {
        //     this.props.homeworkSubject(this.props.subjects.allIds[1]);
        // }
        // if (this.props.homework.editing) {
        //     this.setState({ imagePreviewUrl: this.props.homework.image });
        // }
    }

    componentDidUpdate(prevProps, prevState) {
        
    }

    handleClose(event) {
        this.props.onClose(event);
        this.props.homeworkReset();
    }

    toggleTip() {
        this.setState({ showTip: !this.state.showTip });
    }

    handleTimeslotChange(selectedDuration) {
        this.props.duration(selectedDuration.value);
    }

    handleRoomChange(event) {
        this.props.room(event.target.value);
    }

    findColor(color) {
        let colors = this.props.colors.allIds.map((id) => this.props.colors.byId[id]);
        let foundColor = colors.filter((clr)=>clr.color == color.color)[0];
        return foundColor.id;
    }

    handleSubjectChange(selectedSubject) {
        let subjects = this.props.subjects.allIds.map((id) => this.props.subjects.byId[id]);
        let chosenSubject = subjects.find((subject) => subject.subject == selectedSubject.value);
        if (chosenSubject) {
            this.props.userSubject(chosenSubject.id);
            this.setState({ subject: chosenSubject });
            this.props.homeworkSubject(chosenSubject.id);
        } else {
            //we need to create this subject for this user
            let defaultSubject = standardSubjects.find((defaultSubject) => defaultSubject.subject  == selectedSubject.value); //check if the subject that was chosen is a default subject
            this.props.storeUserSubject({
                ...defaultSubject,
                subject_abbreviation: defaultSubject.abbreviation,
                teacher: '',
                teacher_abbreviation: '',
                color:  this.findColor({ color: defaultSubject.color })
            }).then((subject) => {
                this.props.userSubject(subject.id);
                this.setState({ subject: subject });
                this.props.homeworkSubject(subject.id);
            });
        }
        this.setState({
            homeworkOpen: true
        });
        
    }

    handleCreateSubject(subject) {
        this.props.storeUserSubject({
            subject: subject,
            subject_abbreviation: subject.substr(0, 2).toUpperCase(),
            teacher: '',
            teacher_abbreviation: '',
            color:  this.getRandomInt(1,17)
        }).then((subject) => {  
            this.props.userSubject(subject.id);
            this.setState({ subject: subject });
            this.props.homeworkSubject(subject.id);
        }).then(() => {
            this.setState({
                homeworkOpen: true
            });
        });

    }

    handleSubjectDataChange(event) {
        const { name, value } = event.target;

        let subject = this.state.subject;
        subject[name] = value;


        if (name == 'teacher') {
            let teacherName = event.target.value;
            teacherName = teacherName.trim();
            var split = teacherName.split(' ');
            if (split.length == 1) {

                let firstLetter = split[0][0] ? split[0][0] + '.' : '';
                subject['teacher_abbreviation'] = firstLetter;

            } else if (split.length > 1) {
                var abbreviation = '';
                var firstLetter = '';
                var lastLetter = '';

                //Take first letter of first index in array
                firstLetter = split[0][0] ? split[0][0] + '.' : '';
                
                //Check if array is longer than 1 -> Then we have multiple names in the array. Check if the last index is not empty -> Otherwise render '' instead of undefined.
                lastLetter = split.length > 1 ? (split[(split.length - 1)] ? split[(split.length - 1)][0] + '.' : '') : '';
                
                abbreviation = firstLetter + lastLetter;

                subject['teacher_abbreviation'] = abbreviation;
            }
        }

        this.setState({ subject: subject, subjectDirty: true });
    }

    handleColorChange(event) {
        let subject = this.state.subject;
        subject.color_id = event.value;
        this.setState({
            subject: subject
        });

    }

    storeHomework() {

        this.props.homeworkStore(this.props.homework).then((result) => {

            if (this.props.homework.directlyCreateTask) {
                this.props.taskStore({
                    name: this.props.homework.description,
                    time: 10,
                    order: 1,
                    homework_id: result.id,
                    status: "not_started"
                });
            }

            this.saveEvent(true);
        });


    }

    openImage(data) {
        var image = new Image();
        image.src = data;
        var w = window.open('');
        w.document.write(image.outerHTML);
    }

    handleRecurranceChange(recurrance) {
        this.props.recurrence(recurrance.value);
    }   

    toggleHomeworkOpen() {
        this.setState({
            homeworkOpen: !this.state.homeworkOpen
        });
    }

    toggleSubjectDetails() {
        this.setState({
            newSubjectDetails: !this.state.newSubjectDetails
        });
    }

    saveEvent(fromHomework) {

        if (this.state.subjectDirty) {
            this.props.updateUserSubject(this.state.subject);
        }

        this.props.storeEvent(this.props.new_event).then(() => {
            this.props.resetNewTimeslot();
            this.props.onClose();
        }).then((result) => {
            if (fromHomework) {
                this.props.homeworkReset();
            }
        });
        
    }

    limitDuration() {
        let selectedHour = this.props.homework.timeslot;
        let durations = [
            ...durationValues
        ];
        durations.length = (this.props.user.amount_of_cards + 1) - selectedHour;
        return durations;
    }

    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    render() {
        let limitedDuration = this.limitDuration();

        const months = [ 'januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', ' december' ];

        let days = [];

        for (let index = 1; index <= 31; index++) {
            days.push(<option key={index} value={index}>{index}</option>);
        }

        let date = new Date(this.props.homework.date);

        const new_usersubject = this.props.new_usersubject;
        const subject = this.state.subject;

        let colorsFormatted = [];

        this.props.colors.allIds.forEach((colorId) => {
            let color = this.props.colors.byId[colorId];
            colorsFormatted.push({
                value: color.id,
                label: color.name,
                color: color.color
            });
        });

        return (
            <Fragment>
                <div styleName="input-content">
                    <div styleName='top-bar'>
                        <h1 styleName="title">Vak</h1>
                    </div>
                    <div styleName='card-content'>
                        <div styleName='subject-wrapper'>
                            <p>Vak*</p>
                            <div styleName="subject-selector">
                                {this.state.subject && this.state.subject.id ? <FontAwesomeIcon styleName='icon' icon={[ 'fas','cog' ]} onClick={ () => this.toggleSubjectDetails()}/> : null}
                                <Creator
                                    handleCreate={this.handleCreateSubject} 
                                    handleChange={this.handleSubjectChange} 
                                    value={valueFromLabel(this.props.subsWithDefault, subject && subject.subject)} 
                                    options={this.props.subsWithDefault.sort(this.sortSubjects)}
                                    placeholder='Schrijf zelf of selecteer vak'/>
                            </div>
                        </div>
                        {this.state.newSubjectDetails && <div styleName='new-subject'>
                            <div styleName='new-subject-wrapper' >
                                <div styleName="abbreviation">
                                    <p>Afkorting*</p>
                                    <input styleName='input-abbreviation' maxLength="3"type='text' value={subject && subject.subject_abbreviation} name="subject_abbreviation" onChange={this.handleSubjectDataChange} id="subject-abbreviation"/>
                                </div>
                                <div styleName="subject-color">
                                    <p>Vakkleur*</p>
                                    <Select
                                        onChange={this.handleColorChange}
                                        value={valueFromId(colorsFormatted, subject && subject.color_id)}
                                        options={colorsFormatted}
                                        isSearchable={false}
                                        styles={colourStyles} 
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                    />
                                </div>
                            </div>
                            <div styleName='new-subject-wrapper' style={{ paddingBottom: '20px' }}>
                                <div styleName="teacher">
                                    <p>Docent</p>
                                    <input styleName='input-teacher' value={(subject && subject.teacher) ? subject.teacher : ''} onChange={this.handleSubjectDataChange} placeholder='Docent naam (optioneel)' maxLength="35" name="teacher" id="teacher" type="text"/>
                                </div>
                                <div styleName="teacher-abbreviation">
                                    <p>Afkorting</p>
                                    <input styleName='input-teacher' value={(subject && subject.teacher_abbreviation) ? subject.teacher_abbreviation : ''} onChange={this.handleSubjectDataChange} maxLength="8" name="teacher_abbreviation" id="teacher-abbreviation" type="text"/>
                                </div>
                            </div>
                        </div>}
                        <div styleName='subject-details-wrapper'>
                            <div styleName="recurrence">
                                <p>Herhaling*</p>
                                <Select onChange={this.handleRecurranceChange}
                                    value={valueFromValue(recurrenceTypes, this.props.new_event && this.props.new_event.recurrence)}
                                    options={recurrenceTypes}
                                    isSearchable={false}
                                    styles={customStyles}
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                />
                            </div>            
                    
                            <div styleName="hours">
                                <p>Lesuren*</p>
                                <Select onChange={this.handleTimeslotChange}
                                    value={valueFromLabel(limitedDuration, this.props.new_event && this.props.new_event.duration)}
                                    options={limitedDuration}
                                    isSearchable={false}
                                    styles={customStyles}
                                    placeholder={''}
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                />
                            </div>

                            <div styleName="room">
                                <p>Lokaal</p>
                                <input value={this.props.new_event.room} onChange={this.handleRoomChange} maxLength='8'/>
                            </div>
                        </div>
                   
                        <div styleName='buttons'>
                            <p onClick={this.handleClose}>Annuleer</p>
                            <p styleName='save' onClick={this.saveEvent}>{this.props.homework.editing ? 'Bijwerken' : 'Opslaan zonder huiswerk'}</p>
                        </div>
                    </div>
                </div>

                <div styleName="input-content" style={{ marginTop: '10px' }}>
                    <div styleName='top-bar'>
                        <h1 styleName="title">Huiswerk</h1>
                        <FontAwesomeIcon icon={[ 'far','angle-down' ]} onClick={ () => this.toggleHomeworkOpen()} styleName={`icon ${this.state.homeworkOpen ? 'rotated' : ''}`}/>
                    </div>
                    <div styleName='card-content'>
                        { this.state.homeworkOpen ?
                            <Fragment>
                                <div styleName='homework-card-wrapper'>
                                    <Subject color={this.state.subject && this.state.subject.color_id ? this.props.colors.byId[this.state.subject.color_id].color : '#fff'} abbreviation={this.state.subject && this.state.subject.subject_abbreviation ? this.state.subject.subject_abbreviation : '-'} style={{ marginLeft: '10px' }} />
                                    <div styleName='homework-details'>
                                        <p><b>{this.state.subject && this.state.subject.id ? this.state.subject.subject : 'Kies eerst een vak'}</b></p>
                                        <p>{nlDateString(this.props.new_event.start_date)}</p>
                                    </div>
                                </div>
                                <InputHomeworkForm />
                                <div styleName='buttons'>
                                    <p onClick={this.handleClose}>Annuleer</p>
                                    <p styleName='save' onClick={this.storeHomework}>{'Opslaan'}</p>
                                </div>
                            </Fragment>
                            :
                            <div styleName='homework-card-wrapper' style={{ marginBottom: '10px' }}>
                                <Subject color={this.state.subject && this.state.subject.color_id ? this.props.colors.byId[this.state.subject.color_id].color : '#fff'} abbreviation={this.state.subject && this.state.subject.subject_abbreviation ? this.state.subject.subject_abbreviation : '-'} style={{ marginLeft: '10px' }} />
                                <div styleName='homework-details'>
                                    <p><b>{this.state.subject && this.state.subject.id ? this.state.subject.subject : 'Kies eerst een vak'}</b></p>
                                    <p>{nlDateString(this.props.new_event.start_date)}</p>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </Fragment>
            
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InputHomework);
